import type { MonthViewDayAgendaCalloutProps } from '../components/MonthViewDayAgendaCallout';
import { AgendaScenarioId, SpacesCalendarAssetEntrySource } from '../constants';
import { getCalendarFolderIdForCompose } from 'owa-calendar-forms-utils/lib/utils/getCalendarFolderIdForCompose';
import { initializeAgenda } from 'owa-agenda-events-list';
import getDefaultStart from 'owa-calendar-forms-common/lib/utils/getDefaultStart';
import { tryShowQuickCompose } from 'owa-calendar-quick-compose/lib/actions/tryShowQuickCompose';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EventScope from 'owa-service/lib/contract/EventScope';
import * as React from 'react';
import { convertToOwaDate } from '../utils/dateUtils';

export default function useMonthViewDayAgendaCalloutState({
    date,
    calendarIds,
    target,
    peekTarget,
    setPeekTarget,
    setIsAgendaVisible,
}: MonthViewDayAgendaCalloutProps) {
    React.useEffect(() => {
        if (target && date) {
            initializeAgenda(
                convertToOwaDate(date),
                calendarIds,
                AgendaScenarioId,
                false,
                false,
                SpacesCalendarAssetEntrySource,
                {
                    maxDays: 1,
                    showDateRangeFooter: false,
                }
            );
        }
    }, [calendarIds, date]);

    React.useEffect(() => {
        setIsAgendaVisible(true);
        setPeekTarget(undefined);
    }, [target]);

    React.useEffect(() => {
        if (peekTarget) {
            setIsAgendaVisible(false);
        }
    }, [peekTarget]);

    const onWheel = React.useCallback((ev: React.WheelEvent<HTMLDivElement>) => {
        // prevent canvas from panning
        ev.stopPropagation();
    }, []);

    const composeCalendarFolderId = getCalendarFolderIdForCompose(calendarIds);

    const onNewEventButtonClick = React.useCallback(() => {
        let initialCalendarEvent = {
            Start: getDefaultStart(convertToOwaDate(date!)),
            ParentFolderId: composeCalendarFolderId,
        } as CalendarEvent;

        tryShowQuickCompose(
            initialCalendarEvent,
            SpacesCalendarAssetEntrySource,
            EventScope.Default,
            (target as HTMLDivElement)!
        );
    }, [date, target, composeCalendarFolderId]);

    return {
        showNewEventButton: !!composeCalendarFolderId,
        onWheel,
        onNewEventButtonClick,
    };
}
